export default __webpack_public_path__ + "assets/community-two-one.9e5a8848f3758a6bb58ccbd9d464f2a5.png";